import { InspectionTimeList, mapInspectionTimeList } from "../SiteVisit/SiteVisitTypes";

/* ****************************************************** Site inspection booking */
export interface SiteInspectionBooking {
    id: number;
    project_id: number;
    folder_id: number;
    site_visit_no: number;
    date: string;
    note: string | null;
    status: "Pending" | "Accepted";
    bi_date: string | null;
    time_id: number | null;
    start_time: string | null;
    end_time: string | null;
    time: InspectionTimeList | null;
}

export const mapSiteInspectionBookingList = (data: any): SiteInspectionBooking => {
    if (!data) {
        throw new Error("Invalid site inspection booking type");
    }

    const response: SiteInspectionBooking = {
        id: data.id,
        project_id: data.project_id,
        folder_id: data.folder_id,
        site_visit_no: data.site_visit_no,
        date: data.date,
        note: data.note,
        status: data.status,
        bi_date: data.bi_date ?? null,
        time_id: data.time_id ?? null,
        start_time: data.start_time ?? null,
        end_time: data.end_time ?? null,
        time: data.time ? mapInspectionTimeList(data.time) : null
    };

    return response;
};

export const mapSiteInspectionBookingLists = (data: any[]): SiteInspectionBooking[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid site inspection booking data");
    }

    return data.map(mapSiteInspectionBookingList);
};
/* ****************************************************************** */